import { FormattedHTMLMessage, injectIntl } from "react-intl";

import { type FormSelectChoice, type InputSelectComponentProps } from "../../../lib/types/types";
import { FormFieldInputSelect } from "../FormFieldInputSelect/FormFieldInputSelect";

export const StateSelect = ({
  value,
  isErrored,
  options,
  onChange,
  intl,
  placeholder = "",
  label = "",
  isRequired = false,
  disabled = false,
}: InputSelectComponentProps) => {
  const stateFieldId = "state";

  return (
    <FormFieldInputSelect
      fieldId={stateFieldId}
      value={options.find((option) => option.value === value)}
      refId="state"
      onChange={(state: FormSelectChoice) => onChange(state)}
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({
          id: "statePlaceholder",
          defaultMessage: "State",
        })
      }
      label={label || <FormattedHTMLMessage id="state" defaultMessage="State" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidState" defaultMessage="Invalid state" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      options={options}
      isRequired={isRequired}
      buttonRef="inputSelectButtonState"
      containerId={`sid-${stateFieldId}__select`}
      disabled={disabled}
      autoComplete="address-level1"
    />
  );
};

export const StateSelectComponent = injectIntl(StateSelect);
